import qs from 'qs';
import { network } from 'services/network';

export const deleteReportTemplate = ({ templateId }: QueryParams) => {
    const reportId = templateId; // template is basically report, BUT I want to use template because it's more clear
    const querystring = qs.stringify({ reportId }, { addQueryPrefix: true, skipNulls: true });
    const url = `api/bo/reporting/deleteReportTemplate${querystring}`;

    return network.post(url).then((response) => {
        return response.data;
    });
};

export interface QueryParams {
    templateId: number;
}
